<template>
  <div id="app">

    <div v-if="!isMobile">
      <el-row style="background-color:#00458E; ">
        <el-col :span="4" class="grid-content">
        </el-col>
        <el-col :span="2">
        </el-col>
        <el-col :span="2"><strong style="color:white; line-height:94px;">后勤服务监督平台</strong></el-col>
        <el-col :span="8">
          <el-menu router :default-active="$route.path" mode="horizontal" @select="handleSelect" background-color="#00458E" text-color="#B0B2B4" active-text-color="#fff" style="border: none">
            <el-menu-item index="/pc" style="height:94px; line-height:94px; font-size:15px">首页</el-menu-item>
            <el-menu-item index="/casForm" style="height:94px; line-height:94px; font-size:15px">发帖</el-menu-item>
            <el-menu-item v-if="casAuthorization == ''" index="/PCLogin" style="margin-right: 0px; height:94px; line-height:94px; font-size:15px">登录</el-menu-item>
            <el-menu-item v-if="casAuthorization != ''" index="/mine" style="margin-right: 0px; height:94px; line-height:94px; font-size:15px">我的</el-menu-item>
            <el-menu-item index="/news" style="margin-right: 0px; height:94px; line-height:94px; font-size:15px">动态</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="5" class="grid-content">
        </el-col>
      </el-row>

      <!-- main部分内容start -->
      <el-main class="main">
        <!-- <router-view /> -->
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </el-main>
    </div>
    <div v-else>
      <router-view/>
    </div>
  </div>
</template>

<script>
  import {getUserInfoByToken, logonSSO, menHuUrl, pclogonSSO} from "./api/data";
export default {
  name: 'App',
  data() {
    return {
      casAuthorization: '',
      activeIndex: '/',
      isMobile:false
    }
  },
  components:{
  },
  mounted() {
    this._isMobile();


  },
  methods: {

    _isMobile(){
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
       if(flag==null){
         this.isMobile = false
          //集成单点登录
         let token = decodeURIComponent((new RegExp('[?|&]' +  'token' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
           if(token!=null && token.length>0){
             //实现门户网站的单点登录 根据token获取用户信息
             getUserInfoByToken(token).then((res) => {
               window.localStorage.clear();//清除所有之前的localStorage
               //console.log(res);
               // type ：角色类型 1：监督平台管理员；2：报修管理员；3：教职工：4维修人员：5学生 6 超级管理员
               let  userId  = res.data.data.userId;//用户的登录账号
               if(userId==""){//跳转到统一认证中心登录界面
                 window.location.href = menHuUrl;
               }else {
                 let type  = res.data.data.type
                 pclogonSSO(userId).then(res=>{
                   if(res.data.success==true){
                     localStorage.setItem("casUser", JSON.stringify(res.data))
                   }
                   else{
                     //跳转到统一认证中心登录界面
                     window.location.href = menHuUrl;
                   }
                 }).catch(error=>{
                   console.log("错误"+error);
                 })

               }

             });
           }
         setTimeout(()=>{
           let data = JSON.parse(localStorage.getItem("casUser"));
           //console.log("dataapp")
           //console.log(data)
           if (data) {
             let token = data.data.token
             //console.log("token1"+token)
             this.casAuthorization = token
           } /*else {
           //未登录，跳转到登录页面
           console.log("m PCLogin:")
           this.$router.push('/PCLogin')
         }*/

         },1000)

       }else{
         this.isMobile = true

       }
      //return flag;
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    }
  }
}



</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /*margin-top: 40px;*/
  /*margin-bottom:53px;*/
}
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #C7C9CC;
  border-radius: 50px;
}

body {
  margin: 0px;
  padding: 0px;
  padding-top: 0px;
  /* background: url(./assets/bg.jpg) no-repeat right 20% top 15%; */
/* background: url(./assets/bg.png);*/
  background-attachment: fixed;
  background-size: 900%
  /* background-color: #ecedf2; */
  /* background-size:cover; */
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin: 0px;
  padding: 0px;
  position: relative;
  /* overflow-y:scroll */
}

.el-header,
.el-footer {

  /* color: #333; */
  line-height: 60px;
  /* padding-left: 20%;
    padding-right: 20%; */
}


.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.bg-purple {
  background: #d3dce6;
}

.main {
  /* margin-top: 5px; */
}

.my-header {
  /* border-bottom:1px solid #E2E6EB; box-shadow: 1px 1px 2px #E2E6EB; */
  /* background-color: #409EFF; */
  /* background: url(./assets/bg.jpg) no-repeat; */
}

.my-menu {
  border: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/App.vue